import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 flex w-screen justify-center overflow-y-auto bg-zinc-950/25 px-2 py-2 focus:outline-0 sm:px-6 sm:py-8 lg:px-8 lg:py-16 dark:bg-zinc-950/50" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 w-screen overflow-y-auto pt-6 sm:pt-0" }
const _hoisted_3 = { class: "grid min-h-full grid-rows-[1fr_auto] justify-items-center sm:grid-rows-[1fr_auto_3fr] sm:p-4" }

import { 
		clsx
	} from 'clsx'
	
	import {
		Dialog,
		DialogPanel,
		TransitionChild,
		TransitionRoot
	} from '@headlessui/vue'

	import {
		ref
	} from 'vue'

	// eslint-disable-next-line
	
	const __default__ = { name: 'VDialog' } // name the component
  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		className: {
			type: String,
			default: ""
		},
		onClose:{
			type: Function,
			default: () => {return}
		},
		open: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: "lg"
		}
	},
  setup(__props) {

	const props = __props

	const dialogPanelRef = ref(null)

	const sizes: {[k: string]: string} = {
		'xs': 'sm:max-w-xs',
		'sm': 'sm:max-w-sm',
		'md': 'sm:max-w-md',
		'lg': 'sm:max-w-lg',
		'xl': 'sm:max-w-xl',
		'2xl': 'sm:max-w-2xl',
		'3xl': 'sm:max-w-3xl',
		'4xl': 'sm:max-w-4xl',
		'5xl': 'sm:max-w-5xl',
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: __props.open
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-50",
        "initial-focus": dialogPanelRef.value,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (__props.onClose()))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-100",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-100",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-100",
                "enter-from": "opacity-0 translate-y-12 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-100",
                "leave-from": "opacity-100 translate-y-0",
                "leave-to": "opacity-0 translate-y-12 sm:translate-y-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    ref_key: "dialogPanelRef",
                    ref: dialogPanelRef,
                    class: _normalizeClass(_unref(clsx)(
								__props.className,
								sizes[__props.size],
								'row-start-2 w-full min-w-0 rounded-t-3xl bg-white p-[--gutter] shadow-lg [--gutter:theme(spacing.8)] sm:mb-auto sm:rounded-2xl dark:bg-zinc-900 forced-colors:outline'))
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      }, 8, ["initial-focus"])
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})